import { render, staticRenderFns } from "./AmbulatorioList.vue?vue&type=template&id=5d09c824"
import script from "./AmbulatorioList.vue?vue&type=script&lang=js"
export * from "./AmbulatorioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports